import { render, staticRenderFns } from "./training.vue?vue&type=template&id=52033be5&"
import script from "./training.vue?vue&type=script&lang=js&"
export * from "./training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports